/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Access2Inputs */

const en_coinvestments_dataroom_access2 = /** @type {(inputs: Coinvestments_Dataroom_Access2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access`)
};

/**
* | output |
* | --- |
* | "Access" |
*
* @param {Coinvestments_Dataroom_Access2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_access2 = /** @type {((inputs?: Coinvestments_Dataroom_Access2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Access2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_access2(inputs)
});
export { coinvestments_dataroom_access2 as "coInvestments_dataRoom_access" }